<template>
  <v-row justify="center" class="ma-0">
    <v-col cols="12" class="pa-0">
      <v-toolbar :color="getNoticeColor(item)" height="60" dark class="elevation-0">
        <v-icon medium>{{ getNoticeIcon(item) }}</v-icon>
        <v-toolbar-title class="pl-2">{{ item.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon small @click.stop="onClose()"><v-icon>close</v-icon></v-btn>
      </v-toolbar>
    </v-col>
    <v-col cols="12" class="pa-0">
      <v-card>
        <v-card-text class="py-0">
          <v-container>
            <v-row>
              <template v-if="item.type == 1">
                <v-col cols="12" class="pa-0 text-center">
                  <span class="pr-2">開催日：</span>
                  <span class="headline">{{ item.date }}</span>
                  <span class="px-2">時間：</span>
                  <span class="headline">{{ item.time }}</span>
                </v-col>
                <v-col cols="12" class="px-0">
                  <v-textarea
                    label="概要"
                    prepend-inner-icon="mdi-pencil-box"
                    :value="item.description"
                    outlined
                    readonly
                    rows="10"
                    class="title"
                    hide-details>
                  </v-textarea>
                </v-col>
              </template>
              <template v-if="item.type == 2">
                <v-col cols="12" class="px-0">
                  <v-textarea
                    label="内容"
                    prepend-inner-icon="mdi-pencil-box"
                    :value="item.description"
                    outlined
                    readonly
                    rows="10"
                    class="title"
                    hide-details>
                  </v-textarea>
                </v-col>
              </template>
              <template v-if="item.type == 3">
                <v-col cols="12" class="pa-0 text-center">
                  <span class="pr-2">実施日：</span>
                  <span class="headline error--text">{{ item.date }}</span>
                  <span class="px-2">時間：</span>
                  <span class="headline error--text">{{ item.time }}</span>
                </v-col>
                <v-col cols="12" class="px-0">
                  <v-textarea
                    prepend-inner-icon="mdi-pencil-box"
                    label="内容"
                    :value="item.description"
                    outlined
                    readonly
                    rows="10"
                    class="title"
                    hide-details>
                  </v-textarea>
                </v-col>
              </template>
              <template v-if="item.contents.doc">
                <v-col v-if="getDocType(item) == 'drive'" cols="12">
                  <span class="pr-2">資料：</span>
                  <v-chip :color="getNoticeColor(item)" text-color="white" @click="onDocClick(item)">
                    <v-icon small class="pr-1">mdi-file-document</v-icon>
                    {{ getDocName(item)}}
                  </v-chip>
                </v-col>
                <v-col v-else-if="getYouTubeId(item) != ''" cols="12" class="pa-0 text-center">
                  <embed height="207" width="368" :src="'https://www.youtube.com/embed/' + getYouTubeId(item)"/>
                </v-col>
              </template>
              <template v-if="item.type == 1">
                <v-col v-if="item.contents.location" cols="12">
                  <span class="pr-2">場所：</span>
                  <span>{{ getAdress(item) }}</span>
                  <div id="maps" style="height: 320px; width: 100%;">
                    <span class="transparent--text">{{ showMap() }}</span>
                  </div>
                </v-col>
                <v-col v-if="item.url" cols="12" class="pa-0 text-center">
                  <v-chip color="error" text-color="white" @click="onURLClick(item)">
                    <span>お申し込み</span>
                  </v-chip>
                </v-col>
              </template>
              <v-col v-if="item.updatedAt" cols="12" class="pa-0 caption text-right">
                <span>{{ item.updatedAt | moment }}</span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import gmapsInit from '../../utils/gmaps'
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      locations: 'locations/locations',
      shares: 'shares/shares'
    })
  },
  data () {
    return {
      id: null
    }
  },
  props: [ 'mode', 'item' ],
  created () {
    var index = this.shares.findIndex(share => share.key === this.item.contents.doc)
    if (index !== -1) {
      if (this.shares[index].type === 'youtube' && this.mode === 'view') {
        this.id = this.shares[index].contents.video
        var payload = {
          key: this.id,
          status: true,
          uid: this.user.uid
        }
        this.$store.dispatch('sharesStatics/update', payload)
      } else if (this.shares[index].contents.mimeType !== 'application/vnd.google-apps.folder') {
        this.id = this.shares[index].contents.id
      }
    }
  },
  methods: {
    async showMap () {
      var item = null
      if (this.item.contents.location) {
        var index = this.locations.findIndex(loc => loc.key === this.item.contents.location)
        if (index !== -1) {
          item = this.locations[index]
        }
      }
      if (!item) {
        return
      }
      try {
        this.google = await gmapsInit()
        this.geocoder = new this.google.maps.Geocoder()
        this.map = new this.google.maps.Map(document.getElementById('maps'), {
          center: { lat: item.lat, lng: item.lng },
          zoom: 13,
          mapTypeControl: false
        })
        // eslint-disable-next-line
        var marker = new google.maps.Marker({
          position: this.map.getCenter(),
          map: this.map
        })
      } catch (error) {
        if (error) {
          // console.error(error)
        }
      }
    },
    getNoticeColor (item) {
      var index = this.$NOTICE_TYPE.findIndex(notie => notie.key === item.type)
      if (index !== -1) {
        return this.$NOTICE_TYPE[index].color
      }
      return 'primary'
    },
    getNoticeIcon (item) {
      var index = this.$NOTICE_TYPE.findIndex(notie => notie.key === item.type)
      if (index !== -1) {
        return this.$NOTICE_TYPE[index].icon
      }
      return 'mdi-information'
    },
    getDocName (item) {
      var index = this.shares.findIndex(share => share.key === item.contents.doc)
      if (index !== -1) {
        return this.shares[index].name
      }
      return ''
    },
    getAdress (item) {
      if (this.item.contents.location) {
        var index = this.locations.findIndex(loc => loc.key === this.item.contents.location)
        if (index !== -1) {
          return this.locations[index].name
        }
      }
      return ''
    },
    getDocType (item) {
      var index = this.shares.findIndex(share => share.key === item.contents.doc)
      if (index !== -1) {
        return this.shares[index].type
      }
      return ''
    },
    getYouTubeId (item) {
      var index = this.shares.findIndex(share => share.key === item.contents.doc)
      if (index !== -1) {
        return this.shares[index].contents.video
      }
      return ''
    },
    onDocClick (item) {
      var index = this.shares.findIndex(share => share.key === item.contents.doc)
      window.open(this.shares[index].contents.webViewLink, '_blank')
      if (this.id && this.mode === 'view') {
        var payload = {
          key: this.id,
          status: true,
          uid: this.user.uid
        }
        this.$store.dispatch('sharesStatics/update', payload)
      }
    },
    onURLClick (item) {
      window.open(item.url, '_blank')
    },
    onClose () {
      this.$emit('dismissed', null)
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    }
  }
}
</script>
